module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetLow.574fb72.webp";